import * as types from './constants';


export const mediaGenerationQuery = (payload, mediaGenerationApi) => ({
    type: types.MEDIA_GENERATION_REQUEST,
    payload,
    mediaGenerationApi
});